/**
 * pp-mobile-tab-bar — handler para el Chat tab del tab bar mobile.
 *
 * Prioridad de apertura:
 *   1) pp-assistant (Paco) si está montado en la página → lo atiende el
 *      cargador de snippets/pp-assistant.liquid (inline, desde el parseo:
 *      aquí llegaríamos hasta el DOMContentLoaded). Este archivo no hace nada.
 *   2) Fallback al floating button del pp-chat-widget (#pp-chat-btn) si
 *      Paco no está. Eso cubre la página de checkout u otras donde
 *      pp-assistant no se monta.
 *
 * El tab Menú usa data-pp-mobile-drawer-trigger que pp-mobile-drawer.js
 * maneja automáticamente — no requiere wiring aquí.
 */

(function () {
  function init() {
    document.querySelectorAll('[data-pp-mobile-tab-chat]').forEach((tabBtn) => {
      tabBtn.addEventListener('click', (e) => {
        // Con Paco en la página, el toque lo atiende snippets/pp-assistant.liquid
        // (corre en el parseo, este archivo hasta el DOMContentLoaded; perf
        // 5-oct-2026). Disparar aquí también abriría dos veces.
        if (document.querySelector('pp-assistant')) return;
        e.preventDefault();
        const chatBtn = document.getElementById('pp-chat-btn');
        if (chatBtn) chatBtn.click();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
